
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.887 7.793c.475.848 1.02 1.664 1.731 2.407.712.748 1.597 1.429 2.745 2.01a.288.288 0 00.237.012c.11-.041.22-.13.33-.24a3.67 3.67 0 00.301-.365c.44-.576.987-1.29 1.758-.933l.047.025 2.571 1.467c.007.004.017.013.025.016.339.232.478.59.482.993 0 .412-.153.874-.377 1.265-.296.516-.732.857-1.236 1.084-.478.219-1.012.336-1.524.411a5.198 5.198 0 01-2.329-.192c-.753-.232-1.512-.614-2.342-1.122l-.061-.039c-.38-.235-.791-.488-1.194-.785-1.477-1.106-2.98-2.702-3.96-4.46C.271 7.874-.179 6.282.067 4.764c.135-.832.495-1.588 1.122-2.088.546-.437 1.283-.676 2.236-.592.11.007.207.07.258.164l1.648 2.765c.242.31.271.617.14.924-.11.253-.33.484-.631.702-.089.075-.195.151-.305.231-.37.266-.788.572-.644.933l-.004-.01zm3.07-1.32a.472.472 0 11.24-.915c.771.2 1.497.614 2.084 1.158.591.547 1.05 1.231 1.28 1.965a.478.478 0 01-.911.282c-.18-.574-.545-1.116-1.018-1.554a3.965 3.965 0 00-1.674-.936zm.064-2.898a.474.474 0 11.16-.934c1.456.25 2.837.983 3.945 2.012 1.108 1.028 1.947 2.356 2.315 3.795a.478.478 0 01-.926.233c-.324-1.265-1.063-2.433-2.039-3.34-.974-.904-2.185-1.548-3.455-1.766zm.307-2.63a.475.475 0 11.108-.942c2.036.237 3.95 1.163 5.464 2.525 1.518 1.365 2.64 3.172 3.086 5.163a.476.476 0 01-.93.204c-.402-1.796-1.418-3.43-2.795-4.667-1.37-1.233-3.099-2.071-4.933-2.284z"}})])
          )
        }
      }
    